<template>
  <f7-page id="page-sendmoney-choose-transaction-type" name="sendmoney-choose-transaction-type" @page:afterin="afterin();">
    <f7-navbar class="no-border view-mobile">
      <div class="navbar-inner">
        <f7-nav-left class="back-button">
          <f7-link icon-f7="chevron_left" @click="handleBackButton()" color="black"></f7-link>
        </f7-nav-left>
        <f7-nav-right>
          <f7-link></f7-link>
        </f7-nav-right>
      </div>
    </f7-navbar>

    <f7-block>
      <f7-card
        id     = "errorCard"
        class  = "alert mb-20"
        v-show = "alertCard.show"
        :class = "alertCard.alertClass"
        >
          <div v-html="alertCard.title" slot="header"></div>
          <i class="icon f7-icons card-close" @click="alertCard.show=false">xmark</i>
      </f7-card>

      <f7-row>
        <f7-col class="wandr-level-4">{{$t('sendmoney-philgov-page-title')}}</f7-col>
      </f7-row>
    </f7-block>

    <!-- PHILGOV TRANSACTION TYPE -->
    <f7-block>
      <f7-list class="form-group">
        <f7-list-input
          input-id     = "philGovTransactionType"
          id           = "philGovTransactionTypeInput"
          name         = "philGovTransactionType"
          class        = "clickable-row use-chevron mb-md"
          :label       = "$t('sendmoney-philgov-label-transaction-type')"
          :value       = "philGovTransactionType"
          v-show       = "showPhilGovType"
          @change      = "philGovTransactionType = $event.target.value;"
          :disabled    = "disabledInptPhilGovType"
          outline
          floating-label
        >
          <f7-link popover-open=".popover-dropdown-tx-philgov-type" slot="content-start" class="clickable-item"></f7-link>
        </f7-list-input>
        <f7-popover id="dropdownPhilGovTransactionType" class="popover-dropdown-tx-philgov-type dropdown-default dropdown sendmoney-gov" :backdrop="true">
          <f7-list>
            <f7-list-item popover-close link="#" v-for="item in philGovTrxTypeList" :key="item.key" :selected="item.key == philGovTransactionType" @click="eventChangePhilpGovTrxType(item.key)">
              {{$t("sendmoney-philgov-"+ item.key)}}
            </f7-list-item>
          </f7-list>
        </f7-popover>
      </f7-list>
    </f7-block>

    <!-- LOAN NUMBER -->
    <f7-block v-show = "showInputLoanNumber" >
      <f7-list class="form-group">
        <f7-list-input
          input-id     = "loanNumber"
          name         = "loanNumber"
          type         = "text"
          :label       = "$t('sendmoney-philgov-label-loan-number')"
          :value       = "loanNumber"
          @input       = "loanNumber = $event.target.value"
          outline
          floating-label
        ></f7-list-input>
      </f7-list>
    </f7-block>

    <!-- PRN NUMBER -->
    <f7-block v-show = "showInputSearchPRN" >
      <f7-list class="form-group">
        <f7-list-input
          input-id     = "searchPRN"
          name         = "searchPRN"
          type         = "text"
          :label       = "$t('sendmoney-philgov-label-enter-prn-number')"
          :value       = "prnNo"
          @input       = "prnNo = $event.target.value"
          outline
          floating-label
        >
        <div slot="media">
          <f7-button class="radius-10" large outline @click="getPhilGovePaymentList(true)">{{ $t('general-text-check') }}</f7-button>
        </div>
      </f7-list-input>
      </f7-list>
    </f7-block>

    <f7-block v-show="showPhilGovForm" class="card-container card-20">
      <!-- YEAR & MONTH -->
      <f7-row class="row-with-gap" v-show="bankId==4520 && showInputYear">
        <f7-col>
          <f7-list class="form-group">
            <f7-list-input
              input-id     = "startYear"
              id           = "startYearInput"
              name         = "startYear"
              class        = "clickable-row use-chevron mb-md"
              :label       = "$t('general-text-year')"
              :value       = "startYear"
              @change      = "startYear = $event.target.value;"
              outline
              floating-label
            >
              <f7-link popover-open=".popover-dropdown-tx-start-year-1" slot="content-start" class="clickable-item"></f7-link>
            </f7-list-input>
            <f7-popover id="dropdownStartYear1" class="popover-dropdown-tx-start-year-1 dropdown-default dropdown sendmoney-gov" :backdrop="true">
              <f7-list>
                <f7-list-item popover-close link="#" v-for="item in startYearList" :key="item.key" :selected="item.key == startYear" @click="eventChangeYear(item.key);">
                  {{item.value}}
                </f7-list-item>
              </f7-list>
            </f7-popover>
          </f7-list>
        </f7-col>

        <f7-col>
          <f7-list form class="form-group">
            <f7-list-input
              input-id     = "startMonth"
              id           = "startMonthInput"
              name         = "startMonth"
              class        = "clickable-row use-chevron mb-md"
              :label       = "$t(inputLabelStartMonth)"
              :value       = "$t('month-'+startMonth+'-mmm')"
              @change      = "startMonth = $event.target.value;"
              outline
              floating-label
              >
              <f7-link popover-open=".popover-dropdown-tx-start-month-1" slot="content-start" class="clickable-item"></f7-link>
            </f7-list-input>
            <f7-popover id="dropdownStartMonth1" class="popover-dropdown-tx-start-month-1 dropdown-default dropdown sendmoney-gov" :backdrop="true">
              <f7-list>
                <f7-list-item popover-close link="#" v-for="item in startMonthList" :key="item.key" :selected="item.key == startMonth" @click="eventChangeMonth(item.key, 'startMonth');">
                  {{$t(item.value)}}
                </f7-list-item>
              </f7-list>
            </f7-popover>
          </f7-list>
        </f7-col>
      </f7-row>

      <!-- YEAR ONLY -->
      <f7-row class="row-with-gap" v-show = "bankId!=4520 && showInputYear">
        <f7-col>
          <f7-list class="form-group">
            <f7-list-input
              input-id     = "startYear2"
              id           = "startYear2Input"
              name         = "startYear2"
              class        = "clickable-row use-chevron mb-md"
              :label       = "$t('general-text-year')"
              :placeholder = "$t('general-text-year')"
              :value       = "startYear"
              :disabled    = "disabledInptYear"
              @change      = "startYear = $event.target.value;"
              outline
              floating-label
            >
              <f7-link popover-open=".popover-dropdown-tx-start-year-2" slot="content-start" class="clickable-item"></f7-link>
            </f7-list-input>
            <f7-popover id="dropdownStartYear2" class="popover-dropdown-tx-start-year-2 dropdown-default dropdown sendmoney-gov" :backdrop="true">
              <f7-list>
                <f7-list-item popover-close link="#" v-for="item in startYearList" :key="item.key" :selected="item.key == startYear" @click="eventChangeYear(item.key);">
                  {{item.value}}
                </f7-list-item>
              </f7-list>
            </f7-popover>
          </f7-list>
        </f7-col>
        <f7-col>
        </f7-col>
      </f7-row>

      <!-- MONTH -->
      <f7-row class="row-with-gap" v-show = "showInputMonth">
        <f7-col>
          <f7-list class="form-group">
            <f7-list-input
              input-id     = "startMonth2"
              id           = "startMonth2Input"
              name         = "startMonth2"
              class        = "clickable-row use-chevron mb-md"
              :label       = "$t(inputLabelStartMonth)"
              :value       = "$t('month-'+startMonth+'-mmm')"
              :disabled    = "disabledInptMonth"
              @change      = "startMonth = $event.target.value;"
              outline
              floating-label
              >
              <f7-link popover-open=".popover-dropdown-tx-start-month-2" slot="content-start" class="clickable-item"></f7-link>
            </f7-list-input>
            <f7-popover id="dropdownStartMonth2" class="popover-dropdown-tx-start-month-2 dropdown-default dropdown sendmoney-gov" :backdrop="true">
              <f7-list>
                <f7-list-item popover-close link="#" v-for="item in startMonthList" :key="item.key" :selected="item.key == startMonth" @click="eventChangeMonth(item.key, 'startMonth')">
                  {{$t(item.value)}}
                </f7-list-item>
              </f7-list>
            </f7-popover>
          </f7-list>
        </f7-col>

        <f7-col>
          <f7-list form class="form-group">
            <f7-list-input
              input-id     = "endMonth"
              id           = "endMonthInput"
              name         = "endMonth"
              class        = "clickable-row use-chevron mb-md"
              :label       = "$t(inputLabelEndMonth)"
              :value       = "$t('month-'+endMonth+'-mmm')"
              :disabled    = "disabledInptMonth"
              @change      = "endMonth = $event.target.value;"
              outline
              floating-label
              >
              <f7-link popover-open=".popover-dropdown-tx-end-month" slot="content-start" class="clickable-item"></f7-link>
            </f7-list-input>
            <f7-popover id="dropdownEndMonth" class="popover-dropdown-tx-end-month dropdown-default dropdown sendmoney-gov" :backdrop="true">
              <f7-list>
                <f7-list-item popover-close link="#" v-for="item in endMonthList" :key="item.key" :selected="item.key == endMonth" @click="eventChangeMonth(item.key, 'endMonth')">
                  {{$t(item.value)}}
                </f7-list-item>
              </f7-list>
            </f7-popover>
          </f7-list>
        </f7-col>
      </f7-row>

      <!-- CONTRIBUTION -->
      <f7-row class="row-with-gap" v-show = "showInputContribution">
        <f7-col>
          <f7-list class="form-group">
            <!-- CONTRIBUTION -->
            <f7-list-input
              input-id     = "contribution"
              id           = "contributionInput"
              name         = "contribution"
              class        = "clickable-row use-chevron mb-md"
              :label       = "$t('sendmoney-philgov-label-contribution')"
              :value       = "contributionDisplay"
              outline
              floating-label
            >
              <f7-link popover-open=".popover-dropdown-tx-contribution" slot="content-start" class="clickable-item"></f7-link>
            </f7-list-input>
            <f7-popover id="dropdownContribution" class="popover-dropdown-tx-contribution dropdown-default dropdown sendmoney-gov" :backdrop="true">
              <f7-list>
                <f7-list-item popover-close link="#" v-for="item in contributionList" :key="item.key" :selected="item.key == endMonth" @click="eventChangeContribution(item);">
                  {{formatCurrency(item.totalMonthlyContribution, 2) || 0}} {{ ' ' + homeCurrency}}
                </f7-list-item>
              </f7-list>
            </f7-popover>

            <li class="mb-md text-align-right text-color-primary pointer">
              <span v-show="bankBranchId == 619405"  @click="handleViewContribution()"><i class="f7-icons vertical-align-top">icon_info_circle</i>View Table</span>
            </li>
          </f7-list>
        </f7-col>
      </f7-row>

      <!-- FLEXI FUND -->
      <f7-row class="row-with-gap" v-show = "showInputFlexiFund">
        <f7-col>
          <f7-list class="form-group">
            <f7-list-input
              input-id     = "flexiFund"
              name         = "flexiFund"
              class        = "mb-0"
              type         = "text"
              pattern      = "[0-9]*"
              inputmode    = "decimal"
              autocomplete = "off"
              :label       = "$t('sendmoney-philgov-label-flexi-fund')"
              :value       = "flexiFund.amount == 0 ? '' : flexiFund.amount"
              @input       = "flexiFund.amountReal = ($event.target.value == '' ? 0 : $event.target.value); calculateAmount(); resetInputState('flexiFund')"
              @blur        = "handleAmountBlur($event.target.id);"
              @focus       = "handleAmountFocus($event.target.id);"
              @keypress.native  = "$event.keyCode == 13 || $event.key.toUpperCase() === 'ENTER' ? (flexiFund.amount = $event.target.value, $event.target.blur()) : ''"
              outline
              floating-label
            ></f7-list-input>
          </f7-list>
        </f7-col>
      </f7-row>

      <!-- MP2 NUMBER -->
      <f7-row class="row-with-gap" v-show = "showInputMP2Number">
        <f7-col>
          <f7-list class="form-group">
            <f7-list-input
              input-id     = "mp2No"
              name         = "mp2No"
              type         = "text"
              :label       = "$t('sendmoney-philgov-label-mp2')"
              :value       = "mp2No"
              @input       = "mp2No = $event.target.value; resetInputState('mp2No')"
              outline
              floating-label
            ></f7-list-input>
          </f7-list>
        </f7-col>
      </f7-row>

      <!-- MONTHLY -->
      <f7-row class="row-with-gap" v-show = "showInputMonthlyAmount">
        <f7-col>
          <f7-list class="form-group">
            <f7-list-input
              input-id     = "monthlyAmount"
              name         = "monthlyAmount"
              class        = "mb-0"
              type         = "text"
              pattern      = "[0-9]*"
              inputmode    = "decimal"
              autocomplete = "off"
              :label       = "$t(inputLabelMonthlyAmount)"
              :disabled    = "disabledInptMonthlyAmount"
              :value       = "monthlyAmount.amount == 0 ? '' : monthlyAmount.amount"
              @input       = "monthlyAmount.amountReal = $event.target.value; calculateAmount(); resetInputState('monthlyAmount')"
              @blur        = "handleAmountBlur($event.target.id);"
              @focus       = "handleAmountFocus($event.target.id);"
              @keypress.native  = "$event.keyCode == 13 || $event.key.toUpperCase() === 'ENTER' ? (monthlyAmount.amount = $event.target.value, $event.target.blur()) : ''"
              outline
              floating-label
            ></f7-list-input>
            <li class="mb-md">
              <span v-show="showMinMaxMonthlyText" class="text-color-gray fs-12">{{$t(minMaxMonthlyText)}}</span>
            </li>
          </f7-list>
        </f7-col>
      </f7-row>

      <!-- TOTAL AMOUNT -->
      <f7-row class="row-with-gap" v-show = "showInputTotalAmount">
        <f7-col>
          <f7-list class="form-group">
            <f7-list-input
              input-id     = "totalAmount"
              name         = "totalAmount"
              class        = "mb-0"
              type         = "text"
              pattern      = "[0-9]*"
              inputmode    = "decimal"
              autocomplete = "off"
              :label       = "$t(inputLabelTotalAmount)"
              :value       = "totalAmount.amount == null ? '' : totalAmount.amount"
              :disabled    = "disabledInptTotalAmount"
              @input       = "totalAmount.amountReal = $event.target.value; resetInputState('totalAmount')"
              @blur        = "handleAmountBlur($event.target.id);"
              @focus       = "handleAmountFocus($event.target.id);"
              @keypress.native  ="$event.keyCode == 13 || $event.key.toUpperCase() === 'ENTER' ? (totalAmount.amount = $event.target.value, $event.target.blur()) : ''"
              outline
              floating-label
            ></f7-list-input>
            <li class="mb-md">
              <span v-show="showMinMaxAmountText" class="text-color-gray fs-12">{{$t(minMaxAmountText)}}</span>
            </li>
          </f7-list>
        </f7-col>
      </f7-row>
    </f7-block>

    <f7-block>
      <f7-button class="mb-sm mt-xxl" :disabled="isFormInputValid ? false : true" large fill @click="handleValidatePhilGovDetails()">
        {{$t('sendmoney-continue')}}
      </f7-button>
    </f7-block>

    <f7-sheet class="wandr-sheet-modal sheet-24" :opened="showModalPRNList"  @sheet:closed="handleCloseModal()" :swipeToClose="true">
      <div class="modal-subtitle mb-md">{{ $t('sendmoney-philgov-text-select-prn') }}</div>

      <div class="card card-20 border-color-primary pointer prn-list" v-for="item in prnList" :key="item.prn" @click="handleSelectPRN(item)">
        <div class="fw-bold mb-sm">
          <div>{{$t('general-text-prn')}}</div>
          <div>{{item.prn}}</div>
        </div>
        <div class="mb-sm">
          <div class="text-color-gray">{{$t('general-text-total-amount')}}</div>
          <div class="fw-medium">{{formatCurrency(item.amount, 2) || 0}} {{homeCurrency}}</div>
        </div>
      </div>

      <div v-if="!isSearchPRN" class="card-container card-coupon mt-20 pointer"  @click="showModalPRNList = false">
        <div class="row no-gap display-flex align-items-center">
          <div class="col-90 display-flex align-items-center wandr-paragraph-2">
            {{ $t('sendmoney-philgov-text-other-trx-type') }}
          </div>
          <div class="col-10 chevron right text-align-right"></div>
        </div>
      </div>
    </f7-sheet>

  </f7-page>
</template>

<script>
  import { mapGetters, mapActions } from "vuex";

  export default{
    data(){
			return{
        alertCard              : { show : false, title : "errror", content : "", alertClass:"alert-danger"},
        bankAccountNo          : 0,
        bankAccountName        : "",
        bankBranchId           : 0,
        bankId                 : 0,
        bankName               : "",
        beneficiaryId          : 0,
        contribution           : 0,
        contributionObj        : [],
        contributionDisplay    : '',
        contributionList       : [],
        deliveryMethodName     : "",
        disabledInptTotalAmount: true,
        disabledInptPhilGovType: false,
        disabledInptMonth      : false,
        disabledInptMonthlyAmount : false,
        disabledInptYear       : false,
        email                  : "",
        endMonth               : 0,
        endMonthList           : [],
        endYear                : null,
        endYearList            : [],
        flexiFund              : { amount : null, amountReal : 0, isFocused  : false },
        homeCountryId          : 167,
        homeCountryName        : "",
        homeCurrency           : "PHP",
        hostCountryId          : 189,
        hostCountryName        : "",
        hostCurrency           : "SGD",
        isFormInputValid       : false,
        inputLabelStartMonth   : "general-text-start",
        inputLabelEndMonth     : "general-text-end",
        inputLabelMonthlyAmount: "general-text-monthly-amount",
        inputLabelTotalAmount  : "general-text-total-amount",
        isSearchPRN            : false,
        loanNumber             : '',
        memberTypeId           : 0,
        minMaxMonthlyText      : 'sendmoney-philgov-amount-min-200-max-450000',
        minMaxAmountText       : 'sendmoney-philgov-amount-min-200-max-450000',
        monthlyAmount          : { amount : null, amountReal : 0, isFocused  : false },
        mp2No                  : '',
        p2hCustomerId          : 0,
        philGovTransactionType : "",
        philGovTrxTypeList     : [],
        prnNo                  : '',
        prnList                : [],
        showPhilGovForm        : false,
        showPhilGovType        : true,
        showInputContribution  : false,
        showInputEndYear       : false,
        showInputFlexiFund     : false,
        showInputLoanNumber    : false,
        showInputMonthlyAmount : false,
        showInputMP2Number     : false,
        showInputMonth         : false,
        showInputYear          : false,
        showInputSearchPRN     : false,
        showInputTotalAmount   : false,
        showMinMaxAmountText   : false,
        showMinMaxMonthlyText  : false,
        showModalPRNList       : false,
        startMonth             : 0,
        startMonthDisplay      : "",
        startMonthList         : [],
        startYear              : null,
        startYearList          : [],
        totalAmount            : { amount : null, amountReal : 0, isFocused  : false },
        totalAmountDisplay     : "",
        transactionTypeId      : 0,
        transactionType        : "",
			}
		},
    mounted(){
      this.showPreloader()
      // Required for everypage. Toggle desktop-view footer.
      this.toggleFooterVisibility(false)
      this.$f7.$('.page-content').on('scroll', (e) => {
        this.toggleFooterVisibility(e.target)
      })

      this.bankAccountNo      = this.$store.state.transaction.bankAccountNo
      this.bankBranchId       = this.$store.state.transaction.bankBranchId
      this.bankId             = this.$store.state.transaction.bankId
      this.bankName           = this.$store.state.transaction.bankName
      this.beneficiaryId      = this.$store.state.transaction.beneficiaryId
      this.bankAccountName    = this.$store.state.transaction.beneficiaryFirstName
      this.email              = this.$store.state.transaction.email
      this.p2hCustomerId      = this.$store.state.transaction.p2hCustomerId
      this.endMonth           = this.$store.state.transaction.endMonth
      this.endYear            = this.$store.state.transaction.endYear

      this.loanNumber         = this.$store.state.transaction.loanNumber
      this.mp2                = this.$store.state.transaction.mp2
      this.prn                = this.$store.state.transaction.prn
      this.startMonth         = this.$store.state.transaction.startMonth
      this.startYear          = this.$store.state.transaction.startYear
      this.flexiFund.amount        = this.formatCurrency(this.$store.state.transaction.flexiFund, 2)       + " " + this.homeCurrency
      this.flexiFund.amountReal    = this.$store.state.transaction.flexiFund
      this.monthlyAmount.amount    = this.formatCurrency(this.$store.state.transaction.monthlyAmount, 2)   + " " + this.homeCurrency
      this.monthlyAmount.amountReal= this.$store.state.transaction.monthlyAmount
      this.totalAmount.amount      = this.formatCurrency(this.$store.state.transaction.homeAmountReal, 2)  + " " + this.homeCurrency
      this.totalAmount.amountReal  = this.$store.state.transaction.homeAmountReal

      if(this.bankBranchId > 0){
        this.philGovTransactionType = this.$t("sendmoney-philgov-"+this.bankBranchId)
        this.getYearList()
      }

      if(this.bankId == 4522){
        this.getPhilGovePaymentList(false)
      }

      this.getBankBranchList()
      this.populatePhilGovFormInput()
      this.renderDropdown()
		},

		computed:{
			...mapGetters('auth', [
				'authenticating',
				'authenticationError',
				'authenticationErrorCode',
				'authenticationSuccess'
			])
		},
    methods:{
      ...mapActions('auth', ['login']),

      afterin(){
        window.gtag('event', 'page_view', {page_title: 'Wandr-E [T] | '+this.$f7route.name, page_path: this.$f7route.path})
      },

      calculateAmount(){
        const self = this
        var period = 0
        if(self.bankBranchId == 619401 || self.bankBranchId == 619404){
          period = self.endMonth - self.startMonth + 1
          if(self.monthlyAmount.amountReal > 0){
            self.totalAmount.amountReal = (self.monthlyAmount.amountReal * period)
            self.totalAmount.amount = self.formatCurrency( self.totalAmount.amountReal, 2) + " " + self.homeCurrency
          }
        }else if(self.bankBranchId == 619405){
          period = self.endMonth - self.startMonth + 1
          if(self.contribution > 0){
            self.totalAmount.amountReal = (self.contribution * period) + parseFloat(self.flexiFund.amountReal)
            self.totalAmount.amount = self.formatCurrency( self.totalAmount.amountReal, 2) + " " + self.homeCurrency
          }
        }
      },

      eventChangeContribution(item){
        const self = this

        self.contributionObj     = []
        self.contribution        = item.totalMonthlyContribution
        self.contributionDisplay = self.formatCurrency(item.totalMonthlyContribution , 2) + ' ' + self.homeCurrency

        if(item.totalMonthlyContribution >= 2600){
          self.showInputFlexiFund = true
        }else{
          self.showInputFlexiFund   = false
          self.flexiFund.amount     = null
          self.flexiFund.amountReal = 0
        }

        self.calculateAmount()
      },

      eventChangePhilpGovTrxType(key){
        const self = this
        self.bankBranchId = key
        self.$store.state.transaction.bankBranchId = key
        self.philGovTransactionType = self.$t("sendmoney-philgov-"+ key)
        self.resetInputForm()
        self.populatePhilGovFormInput()
      },

      eventChangeMonth(month, thisDOMId){
        const self      = this

        if(thisDOMId == "startMonth"){
          self.startMonth     = month
          self.endMonth       = (self.startMonth > self.endMonth) ? self.startMonth : self.endMonth
        }else if(thisDOMId == 'endMonth'){
          self.endMonth = month
        }
        self.validateMonth()
        self.calculateAmount()
      },

      eventChangeYear(year){
        const self = this
        self.startYear = year
        self.alertCard.show = false
        self.getMonthList()
        self.validateMonth()
      },

      validateMonth(){
        const self = this
        var currentDate = new Date()

        if(currentDate.getFullYear() == self.startYear  && self.startMonth < currentDate.getMonth() ){
          self.isFormInputValid = false
          self.showErrorCard(self.$t('sendmoney-philgov-invalid-start-month'))
        }else if(currentDate.getFullYear() == self.startYear  && self.endMonth < currentDate.getMonth()) {
          self.isFormInputValid = false
          self.showErrorCard(self.$t('sendmoney-philgov-invalid-end-month'))
        }else if(self.endMonth < self.startMonth){
          self.isFormInputValid = false
          self.showErrorCard(self.$t('sendmoney-philgov-invalid-end-month'))
        }else{
          self.isFormInputValid = true
          self.alertCard.show   = false
        }
      },

      getBankBranchList(){
        const self = this
        const getBankBranchListPromise = self.$api.beneficiary.getBankBranchList(self.bankId)
        getBankBranchListPromise.then(function(result) {
          Object.keys(result).forEach(key => {
            if(key != 619406){
              self.philGovTrxTypeList.push({key: key, value: result[key]})
            }
          })
        })
      },

      getMonthList(){
        const self          = this
        self.startMonthList = []
        self.endMonthList   = []

        let i = 0
        let j = 0

        for(i; i < 12; i++) {
          self.startMonthList.push({key:  i, value:  'month-'+ i +'-mmmm' })
        }

        for(j; j < 12; j++) {
          self.endMonthList.push({key:  j, value:  'month-'+ j +'-mmmm' })
        }
      },

      getPhilGovContributionlist(){
        const self = this
        const getPhilGovContributionPromise = self.$api.transaction.getPhilGovContributionlist()
        getPhilGovContributionPromise.then(function(result) {
          self.contributionList = result
        })
      },

      getPhilGovePaymentList(isSearch){
        const self = this

        self.prnList = []
        self.isSearchPRN = isSearch

        if(isSearch && self.prnNo.length == 0){
          return
        }

        if(isSearch){
          self.showPreloader()
        }

        var params = {
          "beneficiaryId" : self.beneficiaryId,
          "refNo"         : (isSearch) ? self.prnNo : self.bankAccountNo
        }

        const getPhilGovePaymentListPromise = self.$api.transaction.getPhilGovePaymentList(params, (self.bankBranchId == 0) ? 619405 : self.bankBranchId)
        getPhilGovePaymentListPromise.then(function(result) {

          if(isSearch){
            self.hidePreloader()
          }

          if(result.status == "11226"){
            let prnlist = result.result
            if(isSearch){
              if(prnlist.prn){
                // endMonth and StartMonth minus -1 because return searchPRN in january = 1 format.
                prnlist.endMonth = prnlist.endMonth - 1
                prnlist.startMonth = prnlist.startMonth - 1
                self.prnList.push(prnlist)
              }else{
                self.showErrorCard(self.$t('sendmoney-philgov-validate-prn-11227'))
              }
            }else{

              Object.keys(prnlist).forEach(function(key) {
                prnlist[key].endMonth   = prnlist[key].endMonth - 1
                prnlist[key].startMonth = prnlist[key].startMonth - 1
              })

              self.prnList = prnlist
            }

            if(self.prnList.length > 0){
              self.showModalPRNList = true
            }

          }else if( result.status == "11227"){
            self.showErrorCard(self.$t('sendmoney-philgov-validate-prn-11227'))
          }

        })
      },

      getYearList(){
        const self      = this
        var currentDate = new Date()

        for(let i=0; i < 5; i++) {
          self.startYearList.push({key: currentDate.getFullYear() + i, value: currentDate.getFullYear() + i})
          self.endYearList.push({key: currentDate.getFullYear() + i, value: currentDate.getFullYear() + i})
        }

        self.startYear  = (self.startYear == null)  ? currentDate.getFullYear() : self.startYear
        self.startMonth = (self.startMonth == null) ? currentDate.getMonth()    : self.startMonth
        self.endMonth   = (self.endMonth == null)   ? currentDate.getMonth()    : self.endMonth

        self.getMonthList()
      },

      populatePhilGovFormInput(){
        const self = this

        if(self.bankId == 4520){
          self.resetInputForm()
          self.showPhilGovForm         = true
          self.disabledInptPhilGovType = true
          self.philGovTransactionType  = "PhilHealth"
          self.showInputYear           = true
          self.inputLabelStartMonth    = "general-text-month"
          self.showInputTotalAmount    = true
          self.disabledInptTotalAmount = true
          self.totalAmount.amountReal  = 2400
          self.totalAmount.amount      = self.formatCurrency(self.totalAmount.amountReal, 2) + " " + self.homeCurrency
          self.isFormInputValid        = true
          self.bankBranchId            = 619400
        }else{

          if(self.bankBranchId > 0){
            self.showPhilGovForm       = true
            self.isFormInputValid      = true
            self.showInputTotalAmount  = true
          }

          if(self.bankBranchId == 619407){
            self.showInputSearchPRN        = true
            self.showPhilGovForm           = false
            self.isFormInputValid          = false
            self.showInputMonthlyAmount    = true
            self.inputLabelMonthlyAmount   = "general-text-amount"
            self.disabledInptMonth         = true
            self.disabledInptYear          = true
            self.disabledInptMonthlyAmount = true
            self.disabledInptTotalAmount   = true
            self.showMinMaxMonthlyText     = true
          }

          if(self.bankBranchId == 619401 || self.bankBranchId == 619404 || self.bankBranchId == 619405 || self.bankBranchId == 619408){
            self.showInputYear           = true
            self.showInputMonth          = true
          }

          if(self.bankBranchId == 619404 || self.bankBranchId == 619408){
            self.showInputLoanNumber   = true
          }

          if(self.bankBranchId == 619402 || self.bankBranchId == 619403 || self.bankBranchId == 619408){ // SHORTTERM
            self.inputLabelTotalAmount   = "general-text-amount"
            self.showMinMaxAmountText    = true
            self.disabledInptTotalAmount = false
          }

          if(self.bankBranchId == 619402){
            self.showInputMP2Number      = true
            self.minMaxAmountText        = "sendmoney-philgov-amount-min-500-max-450000"
          }

          if(self.bankBranchId == 619401 || self.bankBranchId == 619404){ //SAVING and HOUSE LOAN
            self.showInputMonthlyAmount  = true
            self.disabledInptTotalAmount = true
            self.showMinMaxMonthlyText   = true
          }else if(self.bankBranchId == 619405 ){
            self.showInputContribution   = true
            self.disabledInptTotalAmount = true
            if(self.contributionList.length <= 0){
              self.getPhilGovContributionlist()
            }
          }
        }

        self.hidePreloader()
      },

      handleAmountFocus(thisDOMId){
        const self     = this
        let $thisInput = self.$$('#'+thisDOMId);

        if(thisDOMId == "totalAmount"){
          self.totalAmount.isFocused = true;
          self.totalAmount.amount = self.totalAmount.amountReal == 0 ? "" : self.totalAmount.amountReal
        }else if(thisDOMId == "monthlyAmount"){
          self.monthlyAmount.isFocused = true;
          self.monthlyAmount.amount = self.monthlyAmount.amountReal == 0 ? "" : self.monthlyAmount.amountReal
        }else if(thisDOMId == "flexiFund"){
          self.flexiFund.isFocused = true;
          self.flexiFund.amount = self.flexiFund.amountReal == 0 ? "" : self.flexiFund.amountReal
        }

        if(!self.$f7.device.ios){
          $thisInput.attr('type', 'number');
        }
      },

      handleAmountBlur(thisDOMId){
        const self     = this
        let $thisInput = self.$$('#'+thisDOMId);

        if(thisDOMId == "totalAmount"){
          self.totalAmount.isFocused = false;
          self.totalAmount.amount = (self.totalAmount.amountReal == 0 || self.totalAmount.amountReal == null) ? "" : self.formatCurrency(self.totalAmount.amountReal, 2) + " " + self.homeCurrency
        }else if(thisDOMId == "monthlyAmount"){
          self.monthlyAmount.isFocused = false;
          self.monthlyAmount.amount = (self.monthlyAmount.amountReal == 0 || self.monthlyAmount.amountReal == null) ? "" : self.formatCurrency(self.monthlyAmount.amountReal, 2) + " " + self.homeCurrency
        }else if(thisDOMId == "flexiFund"){
          self.flexiFund.isFocused = false;
          self.flexiFund.amount = (self.flexiFund.amountReal == 0 || self.flexiFund.amountReal == null) ? "" : self.formatCurrency(self.flexiFund.amountReal, 2) + " " + self.homeCurrency
        }

        if(!self.$f7.device.ios){
          $thisInput.attr('type', 'text');
        }
      },

      handleCloseModal(){
        this.showModalPRNList = false
      },

      handleSelectPRN(selectedPRN){
        const self = this
        self.showModalPRNList         = false
        self.prnNo                    = selectedPRN.prn
        self.endMonth                 = selectedPRN.endMonth
        self.endYear                  = selectedPRN.endYear
        self.startMonth               = selectedPRN.startMonth
        self.startYear                = selectedPRN.startYear
        self.monthlyAmount.amountReal = selectedPRN.amount
        self.monthlyAmount.amount     = self.formatCurrency( self.monthlyAmount.amountReal, 2) + " " + self.homeCurrency
        self.totalAmount.amountReal   = selectedPRN.amount
        self.totalAmount.amount       = self.formatCurrency( self.totalAmount.amountReal, 2) + " " + self.homeCurrency

        if(self.isSearchPRN){
          self.showPhilGovForm    = true
          self.isFormInputValid   = true
        }else{
          self.bankBranchId       = 619406
          self.$store.state.transaction.bankBranchId = 619406
          self.philGovTransactionType = self.$t("sendmoney-philgov-619406")
          self.handleValidatePhilGovDetails()
        }

      },

      // BUTTON CONTINUE
      handleValidatePhilGovDetails(){
        const self = this
        self.showPreloader()

        if(!self.validateInputForm()){
          self.hidePreloader()
          return
        }else{
          var params = {
            beneficiaryId     : self.beneficiaryId,
            branchId          : self.bankBranchId,
            homeAmount        : self.totalAmount.amountReal,
            startMonth        : 0,
            startYear         : 0,
            endMonth          : 0,
            endYear           : 0,
            mp2               : self.mp2No,
            loanNumber        : self.loanNumber,
            flexiFund         : 0,
            prn               : self.prnNo,
            philGovAmount     : self.totalAmount.amountReal
          }

          if(self.bankBranchId == 619400){ // PHILHEALTH
            params.startYear    = self.startYear
            params.endYear      = self.startYear
            params.startMonth   = self.startMonth + 1 // month 1-12
            params.branchId     = 619400;
          }

          if(self.bankBranchId == 619401 || self.bankBranchId == 619404 || self.bankBranchId == 619405 || self.bankBranchId == 619408){
            params.startYear  = self.startYear
            params.endYear    = self.startYear
            params.startMonth = self.startMonth + 1 // month 1-12
            params.endMonth   = self.endMonth + 1 // month 1-12
          }

          if(self.bankBranchId == 619405){
            params.flexiFund  = self.flexiFund.amountReal
          }

          const getValidatePhilGov = self.$api.transaction.validatePhilGov(params)
          getValidatePhilGov.then(function(result) {
            console.log("getValidatePhilGov response: ", result)
            if(result.status == "11380"){
              // if(result.result.APIResponseCode == "100"){
              //   self.handleNext()
              // }else{
              //   if(result.result.APIResponseCode == undefined){
              //     self.showErrorCard( self.$t('ws-response-ventaja-code-undefined', { zoholink:  process.env.VUE_APP_CUSTOMER_SERVICE_ZOHO_LINK}) )
              //   }else{
              //     self.showErrorCard(self.$t('ws-response-ventaja-code-'+result.result.APIResponseCode))
              //   }
                self.handleNext()
                self.hidePreloader()
              // }
            }else if(result.status == "11381" || result.status == "11382"){
              if(result.result.APIResponseCode == 136){
                self.showErrorCard(self.$t('ws-response-ventaja-code-136'))
              }else if((result.result.APIResponseMessage).length > 0){
                self.showErrorCard(result.result.APIResponseMessage)
              }else{
                self.showErrorCard( this.$t('ws-response-ventaja-code-undefined', { zoholink:  process.env.VUE_APP_CUSTOMER_SERVICE_ZOHO_LINK}) )
              }
              self.hidePreloader()
            }
          })
        }

      },

      handleNext(){
        const self = this
        var transactionData = self.$store.state.transaction
        transactionData.endMonth       = self.endMonth
        transactionData.endYear        = self.endYear
        transactionData.flexiFund      = self.flexiFund.amountReal
        transactionData.loanNumber     = self.loanNumber
        transactionData.mp2No          = self.mp2No
        transactionData.prnNo          = self.prnNo
        transactionData.startMonth     = self.startMonth
        transactionData.startYear      = self.startYear
        transactionData.monthlyAmount  = self.monthlyAmount.amountReal
        transactionData.homeAmountReal = self.totalAmount.amountReal
        transactionData.bankBranchId   = self.bankBranchId

        self.$f7router.navigate("/sendmoney/enter-amount")
        self.hidePreloader()
      },

      resetInputForm(){
        const self = this

        self.loanNumber              = ''
        self.mp2No                   = ''
        self.prnNo                   = ''
        self.endMonthList            = []
        self.endYearList             = []
        self.startMonthList          = []
        self.startYearList           = []

        self.showInputYear           = false
        self.showInputMonth          = false
        self.showInputLoanNumber     = false
        self.showInputSearchPRN      = false
        self.showInputContribution   = false
        self.showInputFlexiFund      = false
        self.showInputMP2Number      = false
        self.showInputMonthlyAmount  = false
        self.showInputTotalAmount    = false

        self.showMinMaxAmountText    = false
        self.showMinMaxMonthlyText   = false

        self.disabledInptMonth         = false
        self.disabledInptYear          = false
        self.disabledInptMonthlyAmount = false

        self.minMaxAmountText        = "sendmoney-philgov-amount-min-200-max-450000"
        self.minMaxMonthlyText       = "sendmoney-philgov-amount-min-200-max-450000"
        self.inputLabelTotalAmount   = "general-text-total-amount"
        self.inputLabelMonthlyAmount = "general-text-monthly-amount"

        self.contribution            = 0
        self.contributionDisplay     = ''
        self.flexiFund.amount        = null
        self.flexiFund.amountReal    = 0
        self.monthlyAmount.amount    = null
        self.monthlyAmount.amountReal= 0
        self.totalAmount.amount      = null
        self.totalAmount.amountReal  = 0

        this.setInputState("loanNumber", true)
        this.setInputState("mp2No", true)
        this.setInputState("contribution", true)
        this.setInputState("flexiFund", true)
        this.setInputState("monthlyAmount", true)
        this.setInputState("totalAmount", true)

        this.getYearList()
      },

      resetInputState(id){
        this.setInputState(id, true)
      },

      showErrorCard(errorMessage) {
        this.alertCard.title      = errorMessage
        this.alertCard.alertClass = 'alert-danger'
        this.alertCard.show       = true
      },

      formatCurrency(num, dec) {
        let val = (Math.round((parseFloat(num) + Number.EPSILON) * 100) / 100).toFixed(dec)
        return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
      },

      validateInputForm(){
        const self = this
        var isInputValid = true

        if(self.bankId == 4521){
          if(self.bankBranchId == 619401 && self.validateInvalidAmount("monthlyAmount", self.monthlyAmount.amountReal, 200, 450000)){
            isInputValid = false
          }else if(self.bankBranchId == 619402 && (self.validateEmpty("mp2No", self.mp2No) || self.validateInvalidAmount("totalAmount", self.totalAmount.amountReal, 500, 450000))){
            isInputValid = false
          }else if(self.bankBranchId == 619403 && self.validateInvalidAmount("totalAmount", self.totalAmount.amountReal, 200, 450000)){
            isInputValid = false
          }else if(self.bankBranchId == 619404 && (self.validateEmpty("loanNumber", self.loanNumber) || self.validateInvalidAmount("totalAmount", self.totalAmount.amountReal, 200, 450000))){
            isInputValid = false
          }
        } else if(self.bankId == 4522){
          if(self.bankBranchId == 619408 && (self.validateEmpty("loanNumber", self.loanNumber)  || self.validateInvalidAmount("totalAmount", self.totalAmount.amountReal, 200, 450000))){
            isInputValid = false
          }else if(self.bankBranchId == 619405){
            if(self.validateEmpty("contribution", self.contribution)){
              isInputValid = false
            }else if(self.contribution >= 2600 && self.validateInvalidAmount("flexiFund", self.flexiFund.amountReal, 0, 450000) ){
              isInputValid = false
            }
          }
        }

        return isInputValid
      },

      validateEmpty(inputName, value){
        if(value == undefined || value.length <= 0 || value <= 0){
          this.setInputState(inputName, this.$t('sendmoney-form-error-empty-'+inputName))
          return true
        }
      },

      validateInvalidAmount(inputName, amount, minAmount, maxAmount){
        if( amount == undefined || amount < minAmount){
          this.setInputState(inputName, this.$t('sendmoney-form-error-min-home-amount', {currency: this.homeCurrency, amount: this.formatCurrency(minAmount, 2)}))
          return true
        }

        if( amount == undefined || amount > maxAmount){
          this.setInputState(inputName, this.$t('sendmoney-form-error-max-home-amount', {currency: this.homeCurrency, amount: this.formatCurrency(maxAmount, 2)}))
          return true
        }
      },

      handleViewContribution(){
        const self = this
        var transactionData = self.$store.state.transaction
        transactionData.endMonth       = self.endMonth
        transactionData.endYear        = self.endYear
        transactionData.flexiFund      = self.flexiFund.amountReal
        transactionData.loanNumber     = self.loanNumber
        transactionData.mp2No          = self.mp2No
        transactionData.prnNo          = self.prnNo
        transactionData.startMonth     = self.startMonth
        transactionData.startYear      = self.startYear
        transactionData.monthlyAmount  = self.monthlyAmount.amountReal
        transactionData.homeAmountReal = self.totalAmount.amountReal
        transactionData.bankBranchId   = self.bankBranchId

        this.$f7router.navigate("/sendmoney/contribution-table")
      },

      handleBackButton(){
        this.$f7router.back({ transition: 'f7-push' })
      },

      async renderDropdown(){
          const self    = this;

          // TRANSACTION TYPE
          const popover1 = ".sendmoney-gov.popover-dropdown-tx-philgov-type";
          const popoverInner1 = ".sendmoney-gov.popover-dropdown-tx-philgov-type .popover-inner";
          const popoverId1 = "dropdownPhilGovTransactionType";
          const inputId1 = "philGovTransactionType";
          const inputListId1 = "#philGovTransactionTypeInput";
          await self.setDropdownDirection(popover1, popoverInner1, popoverId1, inputId1, inputListId1)

          // START YEAR
          const popover2 = ".sendmoney-gov.popover-dropdown-tx-start-year-1";
          const popoverInner2 = ".sendmoney-gov.popover-dropdown-tx-start-year-1 .popover-inner";
          const popoverId2 = "dropdownStartYear1";
          const inputId2 = "startYear";
          const inputListId2 = "#startYearInput";
          await self.setDropdownDirection(popover2, popoverInner2, popoverId2, inputId2, inputListId2)

          // START MONTH
          const popover3 = ".sendmoney-gov.popover-dropdown-tx-start-month-1";
          const popoverInner3 = ".sendmoney-gov.popover-dropdown-tx-start-month-1 .popover-inner";
          const popoverId3 = "dropdownStartMonth1";
          const inputId3 = "startMonth";
          const inputListId3 = "#startMonthInput";
          await self.setDropdownDirection(popover3, popoverInner3, popoverId3, inputId3, inputListId3)

          // START YEAR ONLY
          const popover4 = ".sendmoney-gov.popover-dropdown-tx-start-year-2";
          const popoverInner4 = ".sendmoney-gov.popover-dropdown-tx-start-year-2 .popover-inner";
          const popoverId4 = "dropdownStartYear2";
          const inputId4 = "startYear2";
          const inputListId4 = "#startYear2Input";
          await self.setDropdownDirection(popover4, popoverInner4, popoverId4, inputId4, inputListId4)

          // START MONTH ONLY
          const popover5 = ".sendmoney-gov.popover-dropdown-tx-start-month-2";
          const popoverInner5 = ".sendmoney-gov.popover-dropdown-tx-start-month-2 .popover-inner";
          const popoverId5 = "dropdownStartMonth2";
          const inputId5 = "startMonth2";
          const inputListId5 = "#startMonth2Input";
          await self.setDropdownDirection(popover5, popoverInner5, popoverId5, inputId5, inputListId5)

          // END MONTH
          const popover6 = ".sendmoney-gov.popover-dropdown-tx-end-month";
          const popoverInner6 = ".sendmoney-gov.popover-dropdown-tx-end-month .popover-inner";
          const popoverId6 = "dropdownEndMonth";
          const inputId6 = "endMonth";
          const inputListId6 = "#endMonthInput";
          await self.setDropdownDirection(popover6, popoverInner6, popoverId6, inputId6, inputListId6)

          // CONTRIBUTION
          const popover7 = ".sendmoney-gov.popover-dropdown-tx-contribution";
          const popoverInner7 = ".sendmoney-gov.popover-dropdown-tx-contribution .popover-inner";
          const popoverId7 = "dropdownContribution";
          const inputId7 = "contribution";
          const inputListId7 = "#contributionInput";
          await self.setDropdownDirection(popover7, popoverInner7, popoverId7, inputId7, inputListId7)

      }
    },
  }
</script>